<template>

  <v-menu
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
  >
    <template #activator="{on}">
      <v-btn v-on="on" text>
        <v-icon left>mdi-magnify</v-icon>
        Search (Ctrl+Space)
      </v-btn>
    </template>

    <v-card>
      <v-card-text style="background-color: #efefef">
        <v-row>
          <v-col cols="12">
            <v-text-field
                prepend-icon="mdi-magnify"
                placeholder="Search"
                :clearable=true
                :hide-details=true
                v-model="search"
                :loading="loading"
                ref="searchInput"
                autofocus
            />
          </v-col>
          <v-col cols="12">
            <v-tabs v-model="tabs" height="25"  background-color="#efefef">
              <v-tab>All</v-tab>
              <v-tab>Customers</v-tab>
              <v-tab>Orders</v-tab>
              <v-tab>Products</v-tab>
              <v-tab>Invoices</v-tab>
              <v-tab>Purchase Orders</v-tab>
              <v-tab>Prescriptions</v-tab>
              <v-tab>Sets</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card flat max-height="700" class="overflow-y-auto">
        <v-card-text>
          <ClientResult
              v-if="result.clients && result.clients.length>0"
              :items="result.clients"
              :type="type"
              @close="dialog=false"
              @only="toggleType('client')"
          />
          <OrderResult
              v-if="result.orders && result.orders.length>0"
              :items="result.orders"
              :type="type"
              @close="dialog=false"
              @only="toggleType('order')"
          />
          <ProductResult
              v-if="result.products && result.products.length>0"
              :items="result.products"
              :type="type"
              @close="dialog=false"
              @only="toggleType('product')"
          />

          <InvoiceResult
              v-if="result.invoices && result.invoices.length>0"
              :items="result.invoices"
              :type="type"
              @close="dialog=false"
              @only="toggleType('productSet')"
          />
          <PrescriptionResult
              v-if="result.prescriptions && result.prescriptions.length>0"
              :items="result.prescriptions"
              :type="type"
              @close="dialog=false"
              @only="toggleType('prescription')"
          />
          <PurchaseOrderResult
              v-if="result.pos && result.pos.length>0"
              :items="result.pos"
              :type="type"
              @close="dialog=false"
              @only="toggleType('po')"
          />
          <ProductSetResult
              v-if="result.sets && result.sets.length>0"
              :items="result.sets"
              :type="type"
              @close="dialog=false"
              @only="toggleType('productSet')"
          />
        </v-card-text>
      </v-card>
    </v-card>
  </v-menu>

</template>

<script>

import _ from "lodash";
import ClientResult from "./ClientResult.vue";
import OrderResult from "./OrderResult.vue";
import PrescriptionResult from "./PrescriptionResult.vue";
import ProductResult from "./ProductResult.vue";
import ProductSetResult from "./ProductSetResult.vue";
import PurchaseOrderResult from "./PurchaseOrderResult.vue";
import InvoiceResult from "@components/globalSearch/InvoiceResult.vue";

export default {
  components: {
    InvoiceResult,
    ClientResult, OrderResult, PrescriptionResult, ProductResult, ProductSetResult, PurchaseOrderResult},
  data: () => ({
    search: null,
    result: [],
    displayResult: false,
    loading: false,
    dialog: false,
    tabs: 0,
    type: 'all',
    types: [
      'all',
      'client',
      'order',
      'product',
      'invoice',
      'po',
      'prescription',
      'productSet',
    ]
  }),
  watch: {
    dialog: {
      handler: _.debounce(function (v) {
        if (v) {
          this.$refs.searchInput.focus();
        }
      }, 400)
    },
    search: {
      handler: _.debounce(function () {
        localStorage.setItem('searchTerm', JSON.stringify(this.search))
        this.doSearch();
      }, 400)
    },
    type: {
      handler: _.debounce(function () {
        localStorage.setItem('globalSearchType', JSON.stringify(this.type))
        this.doSearch();
      }, 400)
    },
    tabs() {
      this.type = this.types[this.tabs]
    }
  },
  created() {
    window.addEventListener("keyup", this.keyupHandle);
    const searchTerm = typeof window !== 'undefined' ? localStorage.getItem('searchTerm') : null
    if (searchTerm != null) {
      this.search = JSON.parse(searchTerm ?? '')
    }
    const globalSearchType = typeof window !== 'undefined' ? localStorage.getItem('globalSearchType') : null
    if (globalSearchType != null) {
      this.type = JSON.parse(globalSearchType ?? '')
      this.tabs = this.types.indexOf(this.type)
    }
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.keyupHandle);
  },
  methods: {
    keyupHandle(e) {
      if (e.ctrlKey && e.key == " ") {
        this.dialog = !this.dialog;
      }
    },
    hideResult: function () {
      this.displayResult = false;
    },
    onBlur() {
      _.debounce(function () {
        this.displayResult = false;
      }, 400);
    },
    toggleType(type) {
      this.type = this.type == type ? 'all' : type
    },
    doSearch() {
      if (this.search) {
        this.loading = true;
        this.result = []
        this.$store
            .dispatch("search/search", {term: this.search, type: this.type})
            .then(data => {
              this.result = data;
            })
            .finally(() => {
              this.loading = false
            })
      }
    }
  }
}
</script>